const studentProfiles = [
  {
    firstName: "Evelyn",
    lastName: "Schols",
    phoneNumber: "06-51715395",
    emailAddress: "evelynschols@outlook.com",
    checked: true,
  },
  {
    firstName: "Aranka",
    lastName: "Ruiten",
    phoneNumber: "06-73288823",
    emailAddress: "arankaruiten@gmail.com",
    checked: true,
  },
  {
    firstName: "Floris",
    lastName: "Everts",
    phoneNumber: "06-30479638",
    emailAddress: "floriseverts@hotmail.com",
    checked: true,
  },
  {
    firstName: "Hector",
    lastName: "Kuijl",
    phoneNumber: "06-98195470",
    emailAddress: "hectorkuijl@yahoo.com",
    checked: true,
  },
  {
    firstName: "Martina",
    lastName: "van der Ent",
    phoneNumber: "06-65003865",
    emailAddress: "martinavanderent@aol.com",
    checked: true,
  },
  {
    firstName: "Maurits",
    lastName: "de Vor",
    phoneNumber: "06-76027083",
    emailAddress: "mauritsdevor@outlook.com",
    checked: true,
  },
  {
    firstName: "Rahima",
    lastName: "van der Ven",
    phoneNumber: "06-81727854",
    emailAddress: "rahimavanderven@gmail.com",
    checked: true,
  },
  {
    firstName: "Sandra",
    lastName: "van der Zee",
    phoneNumber: "06-50774851",
    emailAddress: "sandravanderzee@hotmail.com",
    checked: true,
  },
  {
    firstName: "Wietske",
    lastName: "van de Kolk",
    phoneNumber: "06-10560514",
    emailAddress: "wietskevandekolk@yahoo.com",
    checked: true,
  },
  {
    firstName: "Storm",
    lastName: "Vogels",
    phoneNumber: "06-58477525",
    emailAddress: "stormvogels@aol.com",
    checked: true,
  },
];

export default studentProfiles;
